import React from 'react';
import Typography from 'apollo-react/components/Typography';
import { useAuthContext, userManager } from '../contexts/AuthProvider';
import { isInternalDomain } from '../config/appConfig';

const SessionExpired: React.FC = () => {
  const { user } = useAuthContext();

  const handleReload = async (
    e: React.MouseEvent<HTMLAnchorElement | HTMLSpanElement> | React.KeyboardEvent<HTMLSpanElement>
  ) => {
    e.preventDefault();
    e.stopPropagation();

    // Clear any remaining session data
    localStorage.clear();
    sessionStorage.clear();

    // Check if user is from external domain (not in APP_INTERNAL_DOMAINS)
    // Get user email from stored user data
    const storedUser = await userManager.getUser();
    const userEmail = storedUser?.profile?.email || user?.profile?.email;
    const isExternal = userEmail && !isInternalDomain(userEmail.split('@')[1]);

    // For external users, add prompt=login&max_age=0 to force fresh authentication
    if (isExternal) {
      userManager.signinRedirect({
        extraQueryParams: {
          prompt: 'login',
          max_age: '0',
        },
      });
    } else {
      // For internal users, use standard signin redirect (allows SSO)
      userManager.signinRedirect();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    // Trigger on Enter or Space key (standard accessibility practice)
    if (e.key === 'Enter' || e.key === ' ') {
      handleReload(e);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#F5F5F5',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          maxWidth: '800px',
          padding: '60px',
          backgroundColor: '#F5F5F5',
        }}
      >
        <Typography
          className="bold-large-text"
          style={{
            color: '#000000',
            fontSize: '20px',
            lineHeight: '1.8',
            fontWeight: 700,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
          }}
        >
          Your session has expired due to inactivity,{' '}
          <span
            onClick={handleReload}
            onKeyDown={handleKeyDown}
            role="button"
            tabIndex={0}
            aria-label="Click to log in again"
            style={{
              color: '#0557D5',
              textDecoration: 'underline',
              cursor: 'pointer',
              fontWeight: 700,
            }}
          >
            please click here
          </span>{' '}
          to log in again.
        </Typography>
      </div>
    </div>
  );
};

export default SessionExpired;
